"use client";

import { useTranslations } from "@i18n/provider";

/**
 * The coral send affordance shared by the tutor chat widget and the
 * conversation composer. Both render the same 36px gradient circle and the same
 * paper-plane glyph; they differ only in what disables them.
 */
export function SendButton({ onClick, disabled }: { onClick: () => void; disabled: boolean }) {
  const { t } = useTranslations();

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={t("common.send")}
      className="mb-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full transition-all hover:scale-105 active:scale-95 disabled:opacity-40"
      style={{
        background: "linear-gradient(135deg, var(--coral-light) 0%, var(--coral) 100%)",
        boxShadow: "var(--shadow-primary)",
      }}
    >
      <svg viewBox="0 0 20 20" fill="white" className="h-4 w-4">
        <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
      </svg>
    </button>
  );
}
